var _circle, _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowCheck(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 16,
    fill: "#FFCF06"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6619 21.2107L12.8234 15.6441C12.1728 15.0239 11.1385 15.0239 10.4879 15.6441C9.83735 16.2644 9.83735 17.2505 10.4879 17.8708L17.4775 24.5348C18.1281 25.1551 19.179 25.1551 19.8296 24.5348L37.5121 7.69185C38.1626 7.07157 38.1626 6.08549 37.5121 5.46521C36.8615 4.84493 35.8272 4.84493 35.1766 5.46521L18.6619 21.2107Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8841 8.03955C19.0297 5.87672 13.3308 7.16423 9.87797 11.2038C6.42512 15.2433 6.04072 21.0726 8.9332 25.5306C11.8257 29.9885 17.3061 32.0131 22.4025 30.5064C27.4988 28.9997 30.997 24.3206 31 19.0066V17.7656C31 16.9372 31.6716 16.2656 32.5 16.2656C33.3284 16.2656 34 16.9372 34 17.7656V19.0075C33.9962 25.6502 29.6234 31.4999 23.253 33.3833C16.8827 35.2666 10.0322 32.736 6.41653 27.1635C2.80085 21.5909 3.28138 14.3041 7.59752 9.25458C11.9136 4.20508 19.0371 2.59575 25.105 5.29925C25.8617 5.6364 26.2018 6.52315 25.8647 7.27986C25.5275 8.03657 24.6408 8.3767 23.8841 8.03955Z",
    fill: "#3F3F3F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCheck);
export default __webpack_public_path__ + "static/media/YellowCheck.0ef799f9df5eff3ee9605015be2bab9b.svg";
export { ForwardRef as ReactComponent };